// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"237":"1989207b","334":"80ce397f","395":"c282d667","688":"4e4f38ce"}[chunkId] + ".chunk.js";
};